export default "/assets/images/smiling-girl-placeholder.8e7afb30f3e0cf94.jpg";